// @flow

import Cookies from 'js-cookie';
import qs from 'qs';
import 'whatwg-fetch'; // fetch is only implemented in Safari 11+
import CONFIG from 'CONFIG';

const cookies = Cookies.withConverter({
  read(value, name) {
    return decodeURIComponent(value);
  },
  write(value, name) {
    return encodeURIComponent(value);
  },
});

const pciApis = ['savepaymentcard2'];
const currentOperatorId = 64; // Chicago Fleet
const defaults = (endpoint: string) => pciApis.includes(endpoint) ? ({
  query: {
    isfleetapp: '1',
    isfleetadmin: '1',
    operator_id: currentOperatorId,
    operatorid: currentOperatorId,
    operatorId: currentOperatorId,
    whitelabel_operator_id: currentOperatorId,
  },
  credentials: 'omit',
  mode: 'cors',
  headers: {
    Accept: 'application/json,text/html',
  },
  method: 'POST',
}) : ({
  query: {
    isfleetapp: '1',
    isfleetadmin: '1',
    operator_id: currentOperatorId,
    operatorid: currentOperatorId,
    operatorId: currentOperatorId,
    whitelabel_operator_id: currentOperatorId,
  },
  credentials: 'include',
  mode: 'cors',
  headers: {
    Accept: 'application/json,text/html',
  },
  method: 'GET',
});

const getBaseUrl = (endpoint: string) => {
  return pciApis.includes(endpoint) ? CONFIG.BASE_PCI_URL : CONFIG.BASE_URL;
};

export const fetch = (url: string, options: Object = {}) => {
  console.log('fetch', url, options);
  const query = Object.assign({}, defaults(url).query, options.query);
  const opts = Object.assign({}, defaults(url), options);

  return window
    .fetch(`${url}?${qs.stringify(query)}`, opts)
    .then(setAuthCookies)
    .then(checkStatus)
    .then(deserialize);
};

export const download = (url: string, query: Object = {}) => {
  const queryURL = `${getBaseUrl(url)}/${url}?${qs.stringify(
    Object.assign({}, defaults(url).query, query)
  )}`;
  return window.open(queryURL);
};

export const api = <T>(url: string, options: Object = {}): Promise<T> => {
  const query = Object.assign({}, defaults(url).query, options.query);
  const opts = Object.assign({}, defaults(url), options);
  return window
    .fetch(`${getBaseUrl(url)}/${url}?${qs.stringify(query)}`, opts)
    .then(checkStatus) // check http response status
    .then(deserialize) // encode response as json
    .then(setAuthCookies)
    .then(checkStatus); // check api response status
};

const setAuthCookies = res => {
  if (res.data) {
    if (res.data.ppverifiedparker) {
      cookies.set('ppverifiedparker', res.data.ppverifiedparker);
    }
    if (res.data.ppsessiondata) {
      cookies.set('ppsessiondata', res.data.ppsessiondata);
    }
  }
  return res;
};

const checkStatus = res => {
  if (res.status >= 200 && res.status <= 302) {
    return res;
  } else {
    throw res;
  }
};

const deserialize = res => res.json();



// WEBPACK FOOTER //
// ./src/api/fetch.js